export default __webpack_public_path__ + "static/media/globalCodeCreation.197b9341.png";